var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.images
    ? _c("div", { staticClass: "image-gallery container mb-56" }, [
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.images, function(image) {
            return _c("div", { key: image.id, staticClass: "gallery-image" }, [
              _c("img", {
                staticClass: "h-100 w-100",
                attrs: { src: image.sizes.large }
              })
            ])
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }